const REGEX = {
  PASSPORT: /^(?!^0+$)[a-zA-Z0-9]{3,30}$/,
  PHONE_NO:
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
  URL: /((?:https?:\/\/|www\.)(?:[-a-z0-9]+\.)*[-a-z0-9]+.*)/i,
  EMAIL:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  PASSWORD: /^(?!.*\s)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{14,}$/,
  isinReg: /^[A-Z]{2}([A-Z0-9]){9}[0-9]$/,
  ageReg: /^(0?[1-9]|[1-9][0-9]|[1][1-9][1-9]|200)$/,
  incomeReg: /^(?:0|[1-9]\d*)(?:\.(?!.*000)\d+)?$/,
  specialCharReg: /^[a-zA-Z0-9]+$/,
  numReg: /^[0-9]+$/,
  alphabetsReg: /^[A-Za-z\s]+$/,
  alertReg: /^\d*$/,
  alphaRegNoEmptySpace: /^[A-Za-z]+(\s[A-Za-z]+)*$/,
  upperCaseReg: /[A-Z]/,
  numbersReg: /[0-9]/,
  hasSpecialCharReg: /[^A-Za-z0-9]/,
  onlyNumbersRegex: /^\s*(0|[1-9]\d*)\s*$/,
  zipcodeReg: /^(?=.*[A-Za-z0-9])[a-zA-Z0-9\s-]+$/,
  NON_DIGIT: /\D/g,
  ipRegex:
    /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:\/(?:[0-9]|[1-2][0-9]|3[0-2]))?$|^(?:(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,7}:|(?:[a-fA-F0-9]{1,4}:){1,6}:[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,5}(?::[a-fA-F0-9]{1,4}){1,2}|(?:[a-fA-F0-9]{1,4}:){1,4}(?::[a-fA-F0-9]{1,4}){1,3}|(?:[a-fA-F0-9]{1,4}:){1,3}(?::[a-fA-F0-9]{1,4}){1,4}|(?:[a-fA-F0-9]{1,4}:){1,2}(?::[a-fA-F0-9]{1,4}){1,5}|[a-fA-F0-9]{1,4}:(?:(?::[a-fA-F0-9]{1,4}){1,6})|:(?:(?::[a-fA-F0-9]{1,4}){1,7}|:)|fe80:(?::[a-fA-F0-9]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(?:ffff(?::0{1,4}){0,1}:){0,1}(?:(?:25[0-5]|(?:2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(?:25[0-5]|(?:2[0-4]|1{0,1}[0-9]){0,1}[0-9])|(?:[a-fA-F0-9]{1,4}:){1,4}:(?:(?:25[0-5]|(?:2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(?:25[0-5]|(?:2[0-4]|1{0,1}[0-9]){0,1}[0-9]))(?:\/(?:[0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))?$/,
  nameFieldReg: /(^|[\s_])name($|[\s_])/i,
};
export default REGEX;
